import Vue from "vue";

export class View<T> implements IView {

    // TODO view base class
    protected $viewLoaded?: Function;

    constructor() {
        this.setupEvents();
    }

    private setupEvents() {
        document.addEventListener("DOMContentLoaded", () => {
            if (this.$viewLoaded) {
                this.$viewLoaded();
            }
        });
    }
}

export interface IView {

}


// WEBPACK FOOTER //
// ./www/js/Core/View.ts